module.exports = __webpack_public_path__ + "img/icono_portafolio.9a4957ab.svg";